import { render } from "./CreateMeeting.vue?vue&type=template&id=308f1168&scoped=true"
import script from "./CreateMeeting.vue?vue&type=script&lang=js"
export * from "./CreateMeeting.vue?vue&type=script&lang=js"

import "./CreateMeeting.vue?vue&type=style&index=0&id=308f1168&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308f1168"]])

export default __exports__